import { Directive, ElementRef, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'input[type="number"]',
  standalone: true,
})
export class ClearZeroOnFocusDirective {
  constructor(
    private el: ElementRef<HTMLInputElement>,
    @Optional() private control: NgControl,
  ) {}

  @HostListener('focus')
  onFocus() {
    if (Number(this.el.nativeElement.value) === 0) this.setValue('');
  }

  @HostListener('blur')
  onBlur() {
    if (this.el.nativeElement.value === '') this.setValue(0);
  }

  private setValue(value: number | string) {
    if (this.control?.control) this.control.control.setValue(value);
    else this.el.nativeElement.value = String(value);
  }
}
